import * as React from 'react';

import WalletIcon from '@keaze/web/public/svg/WalletIcon.svg'
import { Box} from '@mui/system';
import styled from 'styled-components';



import {
    MainContainer,
    Affordability,
    AffordabilityContent,
    AffordabilityButton
    
} from '../styles/Affordability.styles'
import {PageTitle} from "@keaze/web/views/termsOfUse/termsOfUse.styles";

const S = {

    WhatIsImageContainer: styled(Box)`
    ${({ theme: { breakpoints} }) => ` 
          background-repeat: no-repeat;
          background-size: cover;
          border-radius: 0 0 120px 0;
          bottom: 0;
          top: 0px;
          position: relative;
          left: -16px;
          height: 450px;
          margin-bottom: -200px;
          padding-bottom:30px;
  
    ${breakpoints.up('md')} {
              left: unset;
              width: 436px;
              height: 533px;
              position: absolute;
              z-index: 2;
              right: -30%;
              top: -30px;
          }
          ${breakpoints.up('lg')} {  width: 546px;}
    `}
    `,
}

type Props = {
    data: Record<string, any>
};

const AffordabilityCalc = (props: Props) => {
    return (
        <MainContainer>
            <Affordability>
                <AffordabilityContent>
                    <WalletIcon/>
                    <h2>{props.data.title ?? 'Home Stepper - Portal Terms of Use'}</h2>
                    <div dangerouslySetInnerHTML={{__html: props.data.content ?? ''}}></div>
                    {!!props.data.file && (
                            <a href={props.data.file} target="_blank">
                                <AffordabilityButton  variant="outlined">
                                    Download Guide
                                </AffordabilityButton>
                            </a>
                                 )}
                </AffordabilityContent>
                <S.WhatIsImageContainer sx={{
                    backgroundImage: `url(${props.data.image ?? 'images/HomeStepper/AffordabilityCalcDesktopImg.png'})`
                }} />
            </Affordability>
        </MainContainer>
    )
}

export default AffordabilityCalc;
    
  